'use client';

import { useState } from 'react';
import { Video } from 'lucide-react';

/** Only the open detail loads a paused source frame when its saved cover is missing. */
export function KagemaneReferenceVideoCover({ src, poster }: { src: string; poster?: string }) {
  const [failedPoster, setFailedPoster] = useState<string>();
  const [failedVideo, setFailedVideo] = useState(false);
  const usablePoster = poster && poster !== src && failedPoster !== poster
    && !/\.(mp4|mov|webm|m4v|m3u8)(?:[?#]|$)/i.test(poster)
    && !/ci-process(?:=|%3D)snapshot/i.test(poster);
  return <span className="relative grid aspect-square w-full place-items-center overflow-hidden rounded-lg bg-white text-[#53636D]" aria-hidden>
    <Video className="size-6" />
    {usablePoster ? <img src={poster} alt="" className="absolute inset-0 h-full w-full object-cover" onError={() => setFailedPoster(poster)} />
      : !failedVideo && <video src={src} muted playsInline preload="metadata" tabIndex={-1}
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
        onLoadedMetadata={(event) => {
          const media = event.currentTarget;
          // Seeking forces Safari to decode a still instead of displaying an empty video tile.
          if (Number.isFinite(media.duration) && media.duration > 0) media.currentTime = Math.min(0.1, media.duration / 2);
        }}
        onError={() => setFailedVideo(true)} />}
  </span>;
}
